import _createClass from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { delay } from '../../timers';
import managedPromise from '../../managedPromise';
import MetaMaskWallet from './metamask';
import { cloneDeep, isEqual } from 'lodash';
var CONNECT_TIMEOUT_SEC = 1;
var BraveWallet = /*#__PURE__*/function (_MetaMaskWallet) {
  _inherits(BraveWallet, _MetaMaskWallet);
  var _super = _createSuper(BraveWallet);
  function BraveWallet(validChainIds) {
    var _this;
    _classCallCheck(this, BraveWallet);
    // use polling, because on Brave events don't work properly atm
    _this = _super.call(this, validChainIds, true);
    _this.name = 'brave';
    return _this;
  }
  return _createClass(BraveWallet);
}(MetaMaskWallet);
export default BraveWallet;